import { filter } from 'lodash';

/**
 * Checks user subscription types. If user has only free and lifetime sets
 * lifetime subscription as active. I user has lifetime and pro subscription
 * sets pro subscription as active.
 *
 * @param {Array} subscriptions User subscriptions.
 *
 * @returns {object} User subscription;
 */
export default (subscriptions) => {
    const proSubscriptions = filter(subscriptions, (subscription) => {
        return 'pro' === subscription.name && 'canceled' !== subscription.stripe_status;
    });

    // Checks if pro subscription is present and sets it as active
    if (0 < proSubscriptions.length) {
        return proSubscriptions[0];
    }

    const lifetimeSubscription = filter(subscriptions, (subscription) => {
        return 'lifetime' === subscription.name;
    });

    return lifetimeSubscription[0];
};
